export default [
    {
        path: '/flow/design',
        name: '流程设计',
        component: () => import('@/views/approval/flow/designFlow.vue')
    },
    {
        path: '/order/approval',
        name: '订单审批',
        component: () => import('@/views/order/orderView.vue')
    },
    {
        path: '/order/view',
        name: '订单查看',
        component: () => import('@/views/order/orderView.vue')
    },
    {
        path: '/prod/editProduct',
        name: 'editProduct',
        component: () => import('@/views/prod/product/editProduct.vue')
    }
]
